export default __webpack_public_path__ + "static/media/mission-available.6e90f2b5.webp";